const swiper_artists = new Swiper('.swiper-artists', {
    // Optional parameters
    slidesPerView: 1.6,
    spaceBetween: 16,

    breakpoints: {

        420: {
            slidesPerView: 2.4,
            spaceBetween: 20,
        },

        520: {
            slidesPerView: 2.5,
            spaceBetween: 20,
        },

        640: {
            slidesPerView: 2.6,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3.5,
            spaceBetween: 20,
        },
        1240: {
            slidesPerView: 4.4,
            spaceBetween: 30,
        },
        1600: {
            slidesPerView: 4.8,
            spaceBetween: 30,
        },
        1800: {
            slidesPerView: 5.5,
            spaceBetween: 30,
        },
        2200: {
            slidesPerView: 6.5,
            spaceBetween: 30,
        },
        2700: {
            slidesPerView: 7.5,
            spaceBetween: 30,
        },
    },

});

const swiper_cat = new Swiper('.swiper-cat', {
    // Optional parameters
    slidesPerView: 2.6,
    spaceBetween: 16,

    breakpoints: {
        640: {
            slidesPerView: 3.4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4.5,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 6.4,
            spaceBetween: 30,
        },
    },

});

const swiper_more = new Swiper('.swiper-more', {
    // Optional parameters
    loop: true,
    slidesPerView: 2.4,
    spaceBetween: 16,

    breakpoints: {
        640: {
            slidesPerView: 3.4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4.4,
            spaceBetween: 20,
            loop: false,
        },
        1024: {
            slidesPerView: 6,
            spaceBetween: 30,
        },
    },

});

const swiper_more_artist = new Swiper('.swiper-more-artist', {
    // Optional parameters
    loop: true,
    slidesPerView: 2.4,
    spaceBetween: 16,

    breakpoints: {
        640: {
            slidesPerView: 4.2,
            spaceBetween: 20,
        },
        984: {
            slidesPerView: 3.1,
            spaceBetween: 20,
        },

        1024: {
            slidesPerView: 3.2,
            spaceBetween: 20,
        },

        1280: {
            slidesPerView: 3.4,
            spaceBetween: 20,
            loop: false,
        },
        1575: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },

});
//# sourceMappingURL=swiper-controls.js.map
